import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import swal from "sweetalert";
import { Spinner } from "react-bootstrap";
import dayjs from "dayjs";

import { useHistory, useLocation } from "react-router-dom";

import {
  getTemplatesApiHandler,
  createCustTemplateApiHandler,
  deleteGroupingTemplateApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";

import { Button } from "../../elements/Button";
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/searchPri.svg";
import { ReactComponent as PlusIcon } from "../../assets/icons/whitePlus.svg";
import { ReactComponent as MyFinIcon } from "../../assets/icons/myFinCardIcon.svg";
import { ReactComponent as MenuDotIcon } from "../../assets/icons/menuDotBlack.svg";
import DeletePopup from "../../elements/DeletePopup";
import SuccessPopup from "../../elements/SuccessPopup";
import ErrorPopup from "../../elements/ErrorPopup";
import { ReactComponent as RemoveIcon } from "../../assets/icons/Close-green.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/infoGrey.svg";
import user from "../../assets/imgs/user3.jpg";
import libcss from "../../css/library.module.css";

import CustomTemplateModal from "../../components/templateLibrary/CustomTemplateModal";
import LibraryFilterModal from "./components/LibraryFilterModal";

const ExpandableDescription = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;
  const isLong = text.length > 90;
  return (
    <div className="mt-3" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
      <span className={libcss.desc1} style={{ 
          whiteSpace: "pre-wrap", 
          display: expanded ? "block" : "-webkit-box", 
          WebkitLineClamp: expanded ? "unset" : 2, 
          WebkitBoxOrient: "vertical", 
          overflow: "hidden" 
      }}>
        {text}
      </span>
      {isLong && (
        <span 
          onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}
          style={{ textDecoration: "underline", color: "#277154", cursor: "pointer", fontSize: "13px", marginTop: "4px" }}
        >
          {expanded ? "See less" : "See more"}
        </span>
      )}
    </div>
  );
};

const StandaloneLibrary = () => {
  let history = useHistory();
  const location = useLocation();
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterState, setFilterState] = useState([{ column: "", select: "", change: "" }]);
  const [defaultLibraryList, setDefaultLibraryList] = useState([]);
  const [customLibraryList, setCustomLibraryList] = useState([]);
  const [createCustomTemplateModal, setCreateCustomTemplateModal] =
    useState(false);
  const [deleteTemplateId, setDeleteTemplateId] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [openMenuId, setOpenMenuId] = useState(null);
  const menuRef = useRef(null);
  const [loader, setLoader] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [searchText, setSearchText] = useState("");
  const searchRef = useRef(null);
  const [allDefaultTemplates, setAllDefaultTemplates] = useState([]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearch(false);
        let params = new URLSearchParams(location.search);
        if (searchText.trim()) {
          if (params.get('name') !== searchText.trim()) {
            params.set('name', searchText.trim());
            history.push({ search: params.toString() });
          }
        } else {
          if (params.has('name')) {
            params.delete('name');
            history.push({ search: params.toString() });
          }
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchText, location.search, history]);
  const [allTemplates, setAllTemplates] = useState([]);

  useEffect(() => {
    getTemplatesApiHandler({ sortField: "createdAt", sortOrder: "desc" })
      .then((response) => {
        if (response?.data?.success === true) {
          const templates = response?.data?.groupingTemplateArray || [];
          setAllTemplates(templates);
          const defaults = templates.filter(obj => obj.templateType === "default");
          setAllDefaultTemplates(defaults);
        }
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    setDefaultLibraryList([]);
    setCustomLibraryList([]);
    setLoader(true);
    getTemplates();
  }, [location.search]);

  const getTemplates = () => {
    const queryParams = new URLSearchParams(location.search);
    let params = { sortField: "createdAt", sortOrder: "desc" };
    
    if (queryParams.has('name')) params.name = queryParams.get('name');
    if (queryParams.has('parentTemplateID')) params.parentTemplateID = queryParams.get('parentTemplateID');
    if (queryParams.has('createdBy')) params.createdBy = queryParams.get('createdBy');

    getTemplatesApiHandler(params)
      .then((response) => {
        if (response?.data?.success === true) {
          var templatesResp = response?.data?.groupingTemplateArray;
          templatesResp.forEach((obj) => {
            if (obj.templateType === "default") {
              setDefaultLibraryList((prev) => [...prev, obj]);
            }
            if (obj.templateType === "custom") {
              setCustomLibraryList((prev) => [...prev, obj]);
            }
          });
          setLoader(false);
        }
        setLoader(false);
      })
      .catch((error) => {
        setErrorMessage(error?.response?.data?.error || "Unable to get templates");
        setShowErrorPopup(true);
        setLoader(false);
      });
  };

  const createCustTemplate = (payload) => {
    createCustTemplateApiHandler(payload)
      .then((response) => {
        console.log("response", response);
        if (response?.data?.success === true) {
          setSuccessMessage("Custom template created successfully");
          setShowSuccessPopup(true);
          setDefaultLibraryList([]);
          setCustomLibraryList([]);
          getTemplates();
          setCreateCustomTemplateModal(false);
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to create custom template",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to create custom template",
          "error"
        );
      });
  };

  // Close on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenuId(null);
      }
    };

    if (openMenuId) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openMenuId]);

  const deleteGroupingTemplate = (tempId) => {
    setDeleteTemplateId(tempId);
  };

  const confirmDeleteTemplate = () => {
    if (!deleteTemplateId) return;
    setLoader(true);
    deleteGroupingTemplateApiHandler({ groupingTemplateID: deleteTemplateId })
      .then((response) => {
        if (response?.data?.success === true) {
          setSuccessMessage("Template deleted successfully");
          setShowSuccessPopup(true);
          const templatesResp = Array.isArray(response?.data?.groupingTemplateArray)
            ? response.data.groupingTemplateArray
            : null;

          if (templatesResp) {
            const nextDefault = [];
            const nextCustom = [];
            templatesResp.forEach((obj) => {
              if (obj.templateType === "default") nextDefault.push(obj);
              if (obj.templateType === "custom") nextCustom.push(obj);
            });
            setDefaultLibraryList(nextDefault);
            setCustomLibraryList(nextCustom);
          } else {
            setDefaultLibraryList((prev) =>
              prev.filter((obj) => obj._id !== deleteTemplateId)
            );
            setCustomLibraryList((prev) =>
              prev.filter((obj) => obj._id !== deleteTemplateId)
            );
          }
        }
        setLoader(false);
        setDeleteTemplateId(null);
      })
      .catch((error) => {
        console.error(
          "Delete grouping template failed",
          error?.response?.data?.error || error
        );
        setLoader(false);
        setDeleteTemplateId(null);
      });
  };
 
const formatLastEdited = (date) => {
  if (!date) return "";
  const d = dayjs(date);
  if (!d.isValid()) return "";
  return `Last edited: ${d.format("DD-MM-YYYY, hh:mm A")}`;
};
const getRelativeTime = formatLastEdited;

const filteredDefaultLibraryList = defaultLibraryList.filter((obj) => {
  const searchValue = searchText.toLowerCase();

  return (
    obj.name?.toLowerCase().includes(searchValue) ||
    obj.createdByName?.toLowerCase().includes(searchValue)
  );
});

const filteredCustomLibraryList = customLibraryList.filter((obj) => {
  const searchValue = searchText.toLowerCase();

  return (
    obj.name?.toLowerCase().includes(searchValue) ||
    obj.createdByName?.toLowerCase().includes(searchValue)
  );
});

  const handleApplyFilter = (newState, shouldClose = true) => {
    const stateToApply = Array.isArray(newState) ? newState : filterState;
    let params = new URLSearchParams(location.search);
    params.delete('name');
    params.delete('parentTemplateID');
    params.delete('createdBy');

    stateToApply.forEach((filter) => {
      if (filter.column && filter.select) {
        let value = filter.change;
        if (filter.column === 'createdBy') {
          const matchedTemplate = allTemplates.find(
            t => t.createdByData?.name?.toLowerCase().includes(value.toLowerCase())
          );
          if (matchedTemplate && matchedTemplate.createdByData?._id) {
            value = matchedTemplate.createdByData._id;
          }
        }
        
        if (filter.select === "iscontains" && value) {
          params.set(filter.column, value);
        } else if (filter.select === "empty") {
          params.set(filter.column, "null");
        }
      }
    });

    history.push({ search: params.toString() });
    
    if (shouldClose !== false) {
      setSuccessMessage("Filter applied successfully");
      setShowSuccessPopup(true);
      setShowFilterModal(false);
    }
  };

  const handleResetAll = () => {
    setFilterState([{ column: "", select: "", change: "" }]);
    let params = new URLSearchParams(location.search);
    params.delete('name');
    params.delete('parentTemplateID');
    params.delete('createdBy');
    history.push({ search: params.toString() });
    
    setSuccessMessage("Filters reset successfully");
    setShowSuccessPopup(true);
    setShowFilterModal(false);
  };

  return (
    <>
      <div>
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className={commoncss.w100}
            style={{ maxHeight: "100vh", overflowY: "hidden" }}
          >
            <motion.div
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className={commoncss.w100}
              style={{ maxHeight: "95vh", overflowY: "hidden" }}
            >
              <header className={`connections-header ${commoncss.greyBg}`}>
                <span className="header-title">Template Library</span>
                <div className="button-group"></div>
                <div className="header-actions">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "20px",
                    gap: "10px",
                  }}
                >
                <div
                  ref={searchRef}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: showSearch ? "1px solid #c2e6d1" : "1px solid transparent",
                    background: showSearch ? "#f4faf5" : "transparent",
                    borderRadius: "8px",
                    padding: showSearch ? "0 0 0 10px" : "0",
                    width: showSearch ? "250px" : "25px",
                    height: "35px",
                    transition: "width 0.4s ease, padding 0.4s ease, background 0.4s ease, border 0.4s ease",
                    overflow: "hidden"
                  }}
                >
                  <div
                    onClick={() => {
                      if (showSearch) {
                        if (searchText.trim()) {
                          let params = new URLSearchParams(location.search);
                          params.set('name', searchText.trim());
                          history.push({ search: params.toString() });
                        } else {
                          setShowSearch(false);
                          setSearchText("");
                          let params = new URLSearchParams(location.search);
                          if (params.has('name')) {
                            params.delete('name');
                            history.push({ search: params.toString() });
                          }
                        }
                      } else {
                        setShowSearch(true);
                      }
                    }}
                    style={{ cursor: "pointer", display: "flex", flexShrink: 0 }}
                  >
                    <SearchIcon width={showSearch ? 16 : 19} height={showSearch ? 16 : 19} />
                  </div>

                  <input
                    type="text"
                    placeholder="Type to Search..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        let params = new URLSearchParams(location.search);
                        if (searchText.trim()) {
                          params.set('name', searchText.trim());
                        } else {
                          params.delete('name');
                        }
                        history.push({ search: params.toString() });
                      }
                    }}
                    style={{
                      border: "none",
                      outline: "none",
                      background: "transparent",
                      marginLeft: showSearch ? "10px" : "0px",
                      flex: 1,
                      fontSize: "14px",
                      color: "#33584e",
                      opacity: showSearch ? 1 : 0,
                      transition: "opacity 0.4s ease",
                      minWidth: 0,
                      pointerEvents: showSearch ? "auto" : "none"
                    }}
                  />

                  <span
                    onClick={() => {
                      if (searchText.length > 0) {
                        setSearchText("");
                        let params = new URLSearchParams(location.search);
                        params.delete('name');
                        history.push({ search: params.toString() });
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      opacity: searchText.length > 0 ? 1 : 0,
                      pointerEvents: searchText.length > 0 ? "auto" : "none",
                      transition: "opacity 0.2s ease",
                      width: "35px",
                      height: "35px"
                    }}
                  >
                    <RemoveIcon style={{ width: "35px", height: "35px" }} />
                  </span>
                </div>
              </div>

                  <div style={{ marginRight: "15px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, cursor: "pointer" }} onClick={() => setShowFilterModal(true)}>
                    <FilterIcon />
                  </div>
                  <Button
                    icon={<PlusIcon width={18} height={18} />}
                    btnColor={buttoncss.primary}
                    label={"Custom Template"}
                    onClick={() => setCreateCustomTemplateModal(true)}
                  />
                </div>
              </header>
            </motion.div>

            <div className={`${libcss.libHomeBody}`}>
              <div className="mt-3">
                <span
                  className={`${commoncss.labelBlack} ${commoncss.fs19} ml-4`}
                >
                  MyFinalyst Templates (Default)
                </span>
                <motion.div
                  initial={{ y: 100, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: 0, opacity: 0 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  className="modulecards-grid"
                >
                  {filteredDefaultLibraryList.map((obj, idx) => (
                    <div
                      key={obj._id || idx}
                      className={`${libcss.libCard} clickable`}
                      style={{
                        minHeight: "180px",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column"
                      }}
                      onClick={() =>
                        history.push(
                          `/myfinV2/library/viewedit-library/${obj._id}`
                        )
                      }
                    >
                      <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                        <span className={commoncss.dFlexJustifysb}>
                          <span className={commoncss.dFlex}>
                            <MyFinIcon />
                            <span className="ml-2 modulecard-title truncate-2">
                              {obj.name}
                            </span>
                          </span>
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenMenuId(obj._id);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <MenuDotIcon width={20} height={20} />
                          </span>
                        </span>
                        <div style={{ marginTop: "auto", display: "flex", alignItems: "flex-start", gap: "8px", paddingTop: "15px" }}>
                          <InfoIcon width={16} height={16} style={{ flexShrink: 0, marginTop: "2px" }} />
                          <span style={{ fontSize: "13px", color: "#809790", lineHeight: "1.4" }}>
                            The template view only and edits must be made in a copy or by using it as a parent template
                          </span>
                        </div>
                      </div>
                      {openMenuId === obj._id && (
                        <div
                          ref={menuRef}
                          className={libcss.floatingMenu}
                          onMouseLeave={() => {
                            setTimeout(() => setOpenMenuId(null), 120);
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div
                            onClick={() => {
                              history.push(
                                `/myfinV2/library/viewedit-library/${obj._id}`
                              );
                            }}
                          >
                            View
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </motion.div>
              </div>
              <div className="mt-3">
                <span
                  className={`${commoncss.labelBlack} ${commoncss.fs19} ml-4`}
                >
                  Custom Templates
                </span>
                {loader ? (
                  <div className={commoncss.fsTableLoaderDiv}>
                    <Spinner animation="grow" size="sm" />
                    <Spinner animation="grow" style={{ margin: "1rem" }} />
                    <Spinner animation="grow" size="sm" />
                  </div>
                ) : (
                  <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 0, opacity: 0 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                    className="modulecards-grid"
                  >
                    {filteredCustomLibraryList.map((obj) => (
                      <div
                        key={obj._id}
                        className={`${libcss.libCard} clickable`}
                        style={{ minHeight: "180px", position: "relative", display: "flex", flexDirection: "column" }}
                        onClick={() =>
                          history.push(
                            `/myfinV2/library/viewedit-library/${obj._id}`
                          )
                        }
                      >
                        <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                          <span className={commoncss.dFlexJustifysb}>
                            <span className={commoncss.dFlex}>
                              {/* <MyFinIcon /> */}
                              <span className="modulecard-title truncate-2">
                                {obj.name}
                              </span>
                            </span>

                            {/* Menu icon */}
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenMenuId(obj._id);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <MenuDotIcon width={20} height={20}/>
                            </span>
                          </span>

                           <div style={{ display: "flex", alignItems: "center", marginTop: "10px" , cursor: "default"}}>
                             <img
                              src={obj.createdByData?.profile_image?.url || user}
                              alt="creator"
                              style={{
                                width: "30px",
                                height: "28px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                marginRight: "8px",
                              }}
                            />
                            <span style={{ fontSize: "14px", color: "#33584e", fontWeight: 400}}>
                              Created by {obj.createdByData?.name || "User"}
                            </span>
                          </div>

                          <ExpandableDescription text={obj.description} />
                          
                          <div style={{ marginTop: "auto", paddingTop: "20px" }}>
                            <div style={{ fontSize: "12px", fontWeight: 400 , color: "#809790" }}>
                              {formatLastEdited(obj.updatedAt || obj.createdAt)}
                            </div>
                          </div>
                          
                        </div>

                        {/* Floating Menu */}
                        {openMenuId === obj._id && (
                          <div
                            ref={menuRef}
                            className={libcss.floatingMenu}
                            onMouseLeave={() => {
                              setTimeout(() => setOpenMenuId(null), 120);
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div style={{ paddingBottom: 0 }}
                              onClick={() => {
                                console.log("View FS links", obj._id);
                              }}
                            >
                              <span style={{ display: "block", borderBottom: "1px solid #eaeeed", paddingBottom: "8px" }}>
                                View FS links
                              </span>
                            </div>
                            <div style={{ paddingBottom: 0 }}
                              onClick={() => {
                                console.log("Rename", obj._id);
                              }}
                            >
                              <span style={{ display: "block", borderBottom: "1px solid #eaeeed", paddingBottom: "8px" }}>
                                Rename
                              </span>
                            </div>
                            <div style={{ paddingBottom: 0 }}
                              onClick={() => {
                                console.log("Duplicate", obj._id);
                              }}
                            >
                              <span style={{ display: "block", borderBottom: "1px solid #eaeeed", paddingBottom: "8px" }}>
                                Duplicate
                              </span>
                            </div>
                            <div
                              // className={libcss.danger}
                              onClick={() => {
                                deleteGroupingTemplate(obj._id);
                              }}
                            >
                              Delete
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </motion.div>
                )}
              </div>
            </div>
          </motion.div>
        </div>
        {createCustomTemplateModal && (
          <CustomTemplateModal
            defaultLibraryList={defaultLibraryList}
            setCreateCustomTemplateModal={setCreateCustomTemplateModal}
            createCustTemplate={createCustTemplate}
          />
        )}
        <LibraryFilterModal
          show={showFilterModal}
          setFilterShow={setShowFilterModal}
          state={filterState}
          setstate={setFilterState}
          handleApplyFilter={handleApplyFilter}
          handleResetAll={handleResetAll}
          defaultLibraryList={allDefaultTemplates}
        />
        <DeletePopup
          isOpen={!!deleteTemplateId}
          title="Confirm deletion of custom template"
          message="Once deleted, you will not be able to recover this!"
          onConfirm={confirmDeleteTemplate}
          onCancel={() => setDeleteTemplateId(null)}
        />
        <SuccessPopup
          isOpen={showSuccessPopup}
          message={successMessage}
          onClose={() => setShowSuccessPopup(false)}
        />
        <ErrorPopup
          isOpen={showErrorPopup}
          message={errorMessage}
          onClose={() => setShowErrorPopup(false)}
        />
      </div>
    </>
  );
};

export default StandaloneLibrary;
